"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatMessage(object) {
    return checkExternalChatMessage(object).fulfilled;
}
exports.isExternalChatMessage = isExternalChatMessage;
function checkExternalChatMessage(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasNumber("timestamp").integer(), __1.hasChoice("source", ["internal", "external"]), __1.hasString("externalId").optional(), __1.hasString("sender"), __1.hasChoice("state", ["sent", "delivered"]), __1.hasString("text").optional(), __1.hasObject("media", __1.hasString("location"), __1.hasString("mimeType"), __1.hasString("name"), __1.hasArray("thumbnails", __1.isRecord(__1.hasString("location"), __1.hasNumber("width")))).optional()).withOptions(options).explain();
}
exports.checkExternalChatMessage = checkExternalChatMessage;
//# sourceMappingURL=ExternalChatMessage.js.map